module.exports = __webpack_public_path__ + "img/not_found (1).8f484ca7.jpg";